/* From the approved auth mockup's `.tile` / `.tile.warn` rules. */

.tile {
  display: grid;
  place-items: center;
  width: var(--space-12);
  height: var(--space-12);
  margin-bottom: var(--space-5);
  border-radius: var(--radius-lg);
  background: var(--bg-inset);
  color: var(--text-2);
}

/* The accent variant. One of the screen's two accent uses; the other is the focus ring. */
.accent {
  background: var(--accent-soft);
  color: var(--accent-text);
}

.icon {
  width: var(--space-6);
  height: var(--space-6);
}
